export const LOAN_STATUS_PENDING = 'P';
